const sessionStorageService = {
    getStorageItem: function (key) {
        const storageObject = window.sessionStorage.getItem(key);

        return storageObject ? JSON.parse(storageObject) : null;
    },
    setStorageItem: function (key, data) {
        if (typeof data === 'undefined') {
            window.sessionStorage.removeItem(key);
            return;
        }

        window.sessionStorage.setItem(key, JSON.stringify(data));
    },
};
export default sessionStorageService;